import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=42a32e94&scoped=true&"
import script from "./editCompany.vue?vue&type=script&lang=js&"
export * from "./editCompany.vue?vue&type=script&lang=js&"
import style0 from "./editCompany.vue?vue&type=style&index=0&id=42a32e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a32e94",
  null
  
)

export default component.exports